<template>
  <v-container fluid>
    <v-form :lazy-validation="true" @submit.prevent="handleSubmit" ref="form">
      <!-- Create field for theme-->
      <v-select
        v-model="setting.theme"
        :items="themes"
        :placeholder="$t('settings.themes')"
        :label="$t('settings.themes')"
        :hide-details="false"
      ></v-select>

      <v-switch
        :label="$t('settings.data.toolbarTransparancy')"
        v-model="setting.toolbarTransparent"
      ></v-switch>
      <v-switch
        :label="$t('settings.data.stickySideMenu')"
        v-model="setting.stickySideMenu"
      ></v-switch>
      <v-btn x-large color="primary" type="submit">{{
        $t("common.save")
      }}</v-btn>
    </v-form>
    <!-- license information section for admins -->
    <v-card class="mt-5" flat v-if="userIsAdmin">
      <v-divider></v-divider>
      <v-card-title class="ml-1"> License </v-card-title>
      <v-card-text class="ml-1 font-weight-medium">
        <div class="subtitle-1 font-weight-medium green--text" align="left">
          {{ $t("common.active") }}
        </div>
        <v-row no-gutters>
          <v-col align="left">
            <div class="subtitle-1 font-weight-medium">
              {{ $t("license.licensee") }}
            </div>
            <div>
              {{ $t("license.fields.name") + ": " + this.license.name }}
            </div>
            <div>
              {{ $t("license.fields.email") + ": " + this.license.email }}
            </div>
          </v-col>
          <v-col align="left">
            <div class="subtitle-1 font-weight-medium">
              {{ $t("license.coveredFeatures") }}
            </div>
            <div>
              {{
                $t("license.fields.maxCompanies") +
                ": " +
                this.license.SO_MAX_COMPANIES
              }}
            </div>
            <div>
              {{
                $t("license.fields.decoderIncluded") +
                ": " +
                (this.license.DECODER_ACTIVE
                  ? $t("common.yes")
                  : $t("common.no"))
              }}
            </div>
          </v-col>
          <v-spacer />
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "SettingEdit",
  data() {
    return {
      theme: "Colors",
      themes: ["Scientific", "Colors"],
      setting: {
        theme: "Colors",
        toolbarTransparent: false,
        stickySideMenu: false,
      },
    };
  },

  async created() {
    await this.getUserSettings();
    if (Object.keys(this.userSettings).length < 0) {
      await this.setUserSettings(this.setting);
    }
    this.setting = this.userSettings;
    // Retrieve license info if user is an admin
    if (this.userIsAdmin) await this.getLicenseTerms();
  },

  methods: {
    ...mapActions("configuration", [
      "getUserSettings",
      "setUserSettings",
      "getLicenseTerms",
    ]),
    async handleSubmit() {
      await this.setUserSettings(this.setting);
      this.setting = this.userSettings;
    },
  },

  computed: {
    ...mapState("configuration", ["userSettings", "license"]),
    ...mapState("users", ["currentUser"]),

    userIsAdmin() {
      return this.currentUser.role == "SuperAdmin";
    },
  },
};
</script>